import { axiosGet } from 'Redux/axiosHelper'

export const getAdminAnalytics = async (params: any) => {
  const response = await axiosGet(`v1/admins/analytics/events`, params)
  return response.data
}
